import StaffModal from '../components/modals/Admin/StaffModal';
import ChapelModal from '../components/modals/Admin/ChapelModal';
import TypesModal from '../components/modals/Admin/TypesModal';
import NewPackage from '../components/modals/Admin/NewPackage';
import { useSelector } from 'react-redux';
import AdminNavbar from '../components/layout/Admin/AdminNavbar';
import CategoryModal from '../components/modals/Admin/CategoryModal';
import { selectCurrentAdditionalModalType, selectCurrentShowTypeOfModal, selectCurrentThirdModalType } from '../features/modal/modalSlice';
import CategoryAndProduct from '../components/modals/Admin/CategoryAndProduct';
import PackageModal from '../components/modals/Admin/PackageModal';
import AddQtyModal from '../components/modals/Admin/AddQtyModal';
import ProductModal from '../components/modals/Admin/ProductModal';
import PackageDetailsItem from '../components/modals/Cashier/PackageDetailsItem';
import NewClientModal from '../components/modals/Cashier/NewClientModal';
import ClientPackages from '../components/modals/Cashier/ClientPackages';
import AddPackageModal from '../components/modals/Admin/AddPackageModal';
import ContainerDashboard from '../components/layout/ContainerDashboard';
import SpecialPackageModal from '../components/modals/Admin/SpecialPackageModal';
import { selectPackageViewId } from '../features/client/clientSlice';
import { selectSetupType } from '../features/setup/setupSlice';
import Temperature from '../components/modals/Admin/Temperature';
import Addons from '../components/modals/Admin/Addons';
import Categories from '../components/modals/Admin/Categories';
import Sizes from '../components/modals/Admin/Sizes';

export default function AdminDashboard() {

    const typeAdditionalModal = useSelector(selectCurrentAdditionalModalType);
    const typeOfModalShow = useSelector(selectCurrentShowTypeOfModal);
    const typeOfThirdModal = useSelector(selectCurrentThirdModalType);
    const packageSelectedIdView = useSelector(selectPackageViewId);
    const setup = useSelector(selectSetupType);

    return (
        <>
            <div className='h-screen flex flex-col bg-gray-100'>
                <AdminNavbar/>
                <ContainerDashboard />
            </div>
            {typeOfModalShow === 'staffModal' && <StaffModal />}
            {typeOfModalShow === 'chapelModal' && <ChapelModal />}
            {typeOfModalShow === 'fbTypeModal' && <TypesModal />}
            {typeOfModalShow === 'viewCategoryAndProductModal' && <CategoryAndProduct/>}
            {typeOfModalShow === 'viewPackageModal' && <PackageModal typeOfView={'admin'} />}
            {typeOfModalShow === 'productModal' && <ProductModal/>}
            {typeOfModalShow === 'categoryModal' && <CategoryModal />}
            {typeOfModalShow === 'newPackageModal' && <NewPackage typOfAction={'newPackage'} />}
            {typeOfModalShow === 'updatePackageModal' && <NewPackage typOfAction={'updatePackage'} />}
            {typeAdditionalModal === 'addQtyItem' && <AddQtyModal />} 
            {typeAdditionalModal === 'viewPackageItem' && <PackageDetailsItem selectedId={packageSelectedIdView ?? null} />}

            {typeOfModalShow === 'newClient' && (
                <NewClientModal typeOfAction={'newClient'} />
            )}
            
            {typeAdditionalModal === 'viewClientPackages' && (
                <ClientPackages/>
            )} 
            {typeAdditionalModal === 'updateClient' && (
                <NewClientModal
                    typeOfAction={'update'}
                />
            )} 
            {/* {typeOfThirdModal === 'viewPackageSelected' && (
                <PackageDetailsItem
                    selectedId={selectedPackageId}
                />
            )} */}
            {typeOfThirdModal === 'viewPackageSelected' && (
                <PackageDetailsItem
                    selectedId={packageSelectedIdView ?? null}
                />
            )}
            {typeAdditionalModal === 'addPackage' && (
                <AddPackageModal  />
            )} 
            {typeAdditionalModal === 'viewDefaultPackage' && (
                <PackageDetailsItem
                    selectedId={packageSelectedIdView ?? null}
                />
            )}
            {typeAdditionalModal === 'showSpecialPackageAddItem' && (
                <SpecialPackageModal/>
            )}
            
            {setup === 'setUpTemperature' && (<Temperature/>)}
            {setup === 'setUpAddons' && (<Addons/>)}
            {setup === 'setUpCategory' && (<Categories/>)}
            {setup === 'setUpSize' && (<Sizes/>)}
        </>
    )
}